module.exports = __webpack_public_path__ + "img/map.89cd196c.png";